import { createServerFn } from "@tanstack/react-start";
import { logError, logInfo } from "@/lib/structured-log";
import type {
  DealContactListResponse,
  ListDealContactsApiWorkspacesWorkspaceIdCampaignsCampaignIdDealsDealIdContactsGetParams,
} from "@/lib/api/generated";
import { listDealContactsApiWorkspacesWorkspaceIdCampaignsCampaignIdDealsDealIdContactsGet } from "@/lib/api/generated/campaigns/campaigns";

export const listDealContactsServer = createServerFn({ method: "GET" })
  .validator(
    (data: {
      workspaceId: string;
      campaignId: string;
      dealId: string;
      page?: number;
      page_size?: number;
      order_by?: ListDealContactsApiWorkspacesWorkspaceIdCampaignsCampaignIdDealsDealIdContactsGetParams["order_by"];
    }) => data,
  )
  .handler(async ({ data }): Promise<DealContactListResponse> => {
    const { workspaceId, campaignId, dealId, page, page_size, order_by } = data;

    logInfo("deals.contacts.list.started", {
      workspace_id: workspaceId,
      campaign_id: campaignId,
      deal_id: dealId,
      page,
      page_size,
    });

    try {
      const response =
        await listDealContactsApiWorkspacesWorkspaceIdCampaignsCampaignIdDealsDealIdContactsGet(
          workspaceId,
          campaignId,
          dealId,
          { page, page_size, order_by },
        );

      if (response.status !== 200) {
        logError("deals.contacts.list.failed", {
          status: response.status,
          workspace_id: workspaceId,
          campaign_id: campaignId,
          deal_id: dealId,
        });
        throw new Error(`Failed to list deal contacts: ${response.status}`);
      }

      logInfo("deals.contacts.list.completed", {
        count: response.data.items?.length ?? 0,
      });

      return response.data;
    } catch (error) {
      logError("deals.contacts.list.error", {
        error: error instanceof Error ? error.message : "unknown-error",
        workspace_id: workspaceId,
        campaign_id: campaignId,
        deal_id: dealId,
      });
      throw error;
    }
  });
